module.exports = __webpack_public_path__ + "img/cn.fc2a8188.svg";